import { assertNever } from '@/helpers/utils';

import { ValidReferenceFileType } from './types';

export const mapFileTypeToFileExtension = (fileType: ValidReferenceFileType) => {
  switch (fileType) {
    case 'image/png':
      return 'png';
    case 'image/jpeg':
      return 'jpeg';
    case 'image/jpg':
      return 'jpg';
    case 'image/webp':
      return 'webp';
    default:
      assertNever(fileType);
  }
};
